import React from 'react';
import TemplateRecommendationPresenter, { TEMPLATE_RECOMMENDATION_CONTAINER } from '@com-pc/template-recommendation/template-recommendation-pesenter';
import TemplateRecommendationModel from '@com-pc/template-recommendation/template-recommendation-model';
import connect from '@src/js/separate-logic/connect';

interface ITemplateRecommendationProps {
    isShowTemplateRecommendation: boolean;
}
export class TemplateRecommendation extends React.Component<ITemplateRecommendationProps> {
    public render() {
        const { isShowTemplateRecommendation } = this.props;
        return isShowTemplateRecommendation ? <div id={TEMPLATE_RECOMMENDATION_CONTAINER}/> : null;
    }
}

export default connect(
    TemplateRecommendationPresenter,
    TemplateRecommendationModel,
    TemplateRecommendation,
);
